module.exports = __webpack_public_path__ + "static/media/sensa.cb3a6042.svg";